(function () {
  if (window.__dushaBrewingGuideLoaded) return;
  window.__dushaBrewingGuideLoaded = true;

  const methods = {
    gongfu: {
      kicker: 'CHINA · SHORT REPEATED INFUSIONS',
      title: 'Chinese gongfu',
      intro: 'Gongfu brewing uses a small vessel and a high leaf-to-water ratio. Short infusions let you follow how aroma, texture and finish change across several pours.',
      leaf: '5 g', water: '100 ml', temp: '90–98°C', time: '10–20 sec',
      meta: ['15–30 min', 'Gaiwan or small pot', 'Repeated infusions'],
      steps: [['Warm', 'Rinse the vessel and cups with hot water.'], ['Add the leaf', 'Use enough leaf to loosely cover the base.'], ['Pour and close', 'Add water, cover immediately and begin counting.'], ['Decant fully', 'Pour every drop into a server or cups.'], ['Repeat', 'Add a little time as the leaves open.']],
      note: 'Use the first cup to judge the next one. Too light: extend the following infusion. Too heavy: pour sooner.',
      good: 'Oolong · puerh · Chinese black tea · aged white tea'
    },
    senchado: {
      kicker: 'JAPAN · LOW TEMPERATURE LEAF TEA',
      title: 'Japanese senchadō',
      intro: 'A slower Japanese approach that uses cooler water and careful pouring to draw out sweetness, umami and a soft green finish.',
      leaf: '5 g', water: '120 ml', temp: '55–70°C', time: '60–90 sec',
      meta: ['15 min', 'Kyusu, hōhin or shiboridashi', 'Slow and precise'],
      steps: [['Warm', 'Warm the vessel and cups, then use that water to cool the next pour.'], ['Measure', 'Add the leaf and spread it evenly.'], ['Cool the water', 'Let freshly boiled water fall to the chosen temperature.'], ['Infuse', 'Pour gently and leave the vessel still.'], ['Decant', 'Alternate between cups and finish every drop.']],
      note: 'When the tea feels flat, raise the temperature slightly before extending the time.',
      good: 'Gyokuro · shaded sencha · fine spring sencha'
    },
    sencha: {
      kicker: 'JAPAN · EVERYDAY KYUSU BREWING',
      title: 'Japanese everyday tea',
      intro: 'A practical method for sencha, bancha, genmaicha and hojicha: one small pot, a measured infusion and a complete decant.',
      leaf: '4 g', water: '180 ml', temp: '75–85°C', time: '45–60 sec',
      meta: ['5–10 min', 'Kyusu', 'Everyday pot'],
      steps: [['Warm', 'Rinse the pot and cups.'], ['Add the leaf', 'Use a level measure rather than packing the pot.'], ['Pour', 'Add water at the chosen temperature.'], ['Wait', 'Keep the pot still while the leaves open.'], ['Finish', 'Pour to the last drop and shorten the second infusion.']],
      note: 'Astringency often comes from water that is too hot or liquid left sitting on the leaves.',
      good: 'Sencha · bancha · genmaicha · hojicha'
    },
    cold: {
      kicker: 'JAPAN · COLD EXTRACTION',
      title: 'Japanese cold brew',
      intro: 'Cold water extracts slowly, producing a clear, soft cup with low bitterness and an easy sweetness.',
      leaf: '8–10 g', water: '750 ml', temp: 'Cold', time: '4–8 hr',
      meta: ['4–8 hr', 'Bottle or pitcher', 'Cold extraction'],
      steps: [['Measure', 'Add tea to a bottle or infuser.'], ['Fill', 'Cover with cold filtered water.'], ['Rest', 'Refrigerate for four to eight hours.'], ['Taste', 'Check before leaving the tea overnight.'], ['Strain', 'Remove the leaves and keep chilled.']],
      note: 'For more aroma, use more leaf rather than leaving the same leaves for much longer.',
      good: 'Sencha · jasmine tea · light oolong · white tea'
    },
    ice: {
      kicker: 'JAPAN · ICE-MELT BREWING',
      title: 'Japanese ice brew',
      intro: 'Tea is placed beneath ice and extracted as it melts, concentrating sweetness and texture into a small, slow cup.',
      leaf: '5 g', water: 'Ice only', temp: '0°C', time: '30–60 min',
      meta: ['30–60 min', 'Shiboridashi or small bowl', 'Slow ice melt'],
      steps: [['Add the leaf', 'Spread the tea across a shallow vessel.'], ['Cover with ice', 'Use clean ice with room to melt.'], ['Wait', 'Leave the vessel undisturbed.'], ['Pour', 'Decant the small amount of concentrated tea.'], ['Continue', 'Add cool water for a second infusion.']],
      note: 'This method gives very little liquid. Treat it as a tasting rather than a full mug.',
      good: 'Gyokuro · premium sencha · shaded green tea'
    },
    matcha: {
      kicker: 'JAPAN · WHISKED TEA',
      title: 'Matcha',
      intro: 'Matcha is suspended rather than infused. Sifting, water temperature and whisking create a smooth cup without dry clumps.',
      leaf: '2 g', water: '60–70 ml', temp: '70–80°C', time: '20 sec',
      meta: ['3–5 min', 'Matcha bowl and whisk', 'Whisked suspension'],
      steps: [['Warm', 'Warm the bowl and soften the whisk in hot water.'], ['Sift', 'Pass the matcha through a fine sieve.'], ['Add water', 'Use water below a full boil.'], ['Whisk', 'Move quickly from the wrist in a loose W shape.'], ['Finish', 'Stop when the surface is even and the texture feels light.']],
      note: 'A thick, harsh cup usually needs slightly more water or cooler water before it needs less matcha.',
      good: 'Ceremonial matcha · everyday matcha'
    },
    british: {
      kicker: 'BRITAIN · ONE MEASURED POT',
      title: 'British pot brewing',
      intro: 'One pot, one measured infusion and a generous everyday cup. This method works well for black tea and fuller blends.',
      leaf: '3–4 g', water: '250 ml', temp: '95–100°C', time: '3–4 min',
      meta: ['5 min', 'Teapot or mug infuser', 'One full infusion'],
      steps: [['Warm', 'Warm the pot so the water does not cool immediately.'], ['Measure', 'Use enough leaf for the water volume.'], ['Pour', 'Add freshly boiled water.'], ['Infuse', 'Cover and leave undisturbed.'], ['Strain', 'Remove the leaves completely before serving.']],
      note: 'For milk tea, make the infusion slightly stronger with leaf quantity, not by steeping indefinitely.',
      good: 'Assam · Ceylon · breakfast blends · robust Chinese black tea'
    },
    arabic: {
      kicker: 'GULF HOMES · CARDAMOM BLACK TEA',
      title: 'Tea across Arab homes',
      intro: 'Tea traditions vary across the Arab world. This guide begins with a Gulf-style black tea scented with cardamom and served in small glasses.',
      leaf: '6 g', water: '500 ml', temp: 'Boiling', time: '8–12 min',
      meta: ['10–15 min', 'Stovetop pot', 'Boiled and scented'],
      steps: [['Crush', 'Lightly crush green cardamom pods.'], ['Combine', 'Add water, black tea and cardamom to the pot.'], ['Simmer', 'Keep the heat gentle rather than aggressively boiling.'], ['Sweeten', 'Add sugar according to the table.'], ['Serve', 'Strain into small glasses and refill while hot.']],
      note: 'Cardamom should scent the tea without hiding it. Begin with fewer pods and adjust the next pot.',
      good: 'Strong black tea · Ceylon · Assam'
    },
    samovar: {
      kicker: 'RUSSIA · ZAVARKA & HOT WATER',
      title: 'Russian samovar',
      intro: 'A concentrated teapot of tea, zavarka, is kept warm and diluted cup by cup with hot water from the samovar.',
      leaf: '12–15 g', water: '500 ml concentrate', temp: 'Boiling', time: '10–15 min',
      meta: ['20+ min', 'Samovar and small pot', 'Concentrate + water'],
      steps: [['Heat', 'Bring the samovar water to temperature.'], ['Make zavarka', 'Brew a concentrated pot of tea.'], ['Keep warm', 'Rest the teapot above the samovar.'], ['Pour concentrate', 'Add a small amount to each glass or cup.'], ['Dilute', 'Top with hot water according to strength.']],
      note: 'The concentrate should be strong but still aromatic. Burnt bitterness becomes more obvious after dilution.',
      good: 'Black tea · smoked tea · black tea with herbs'
    }
  };

  const state = { time: 'quick', temperature: 'hot', vessel: 'pot' };

  function methodForFinder() {
    if (state.vessel === 'matcha') return 'matcha';
    if (state.vessel === 'samovar') return 'samovar';
    if (state.temperature === 'cold') return 'cold';
    if (state.temperature === 'ice') return 'ice';
    if (state.vessel === 'gaiwan') return 'gongfu';
    if (state.vessel === 'kyusu') return state.time === 'slow' ? 'senchado' : 'sencha';
    if (state.time === 'slow') return 'arabic';
    return 'british';
  }

  function renderFinder(root) {
    const key = methodForFinder();
    const method = methods[key];
    root.querySelector('[data-result-title]').textContent = method.title;
    root.querySelector('[data-result-copy]').textContent = method.intro;
    root.querySelector('[data-result-time]').textContent = method.meta[0];
    root.querySelector('[data-result-vessel]').textContent = method.meta[1];
    root.querySelector('[data-result-style]').textContent = method.meta[2];
    root.querySelector('[data-open-method]').dataset.brewMethod = key;
  }

  function renderGuide(key) {
    const method = methods[key];
    if (!method) return;
    document.querySelectorAll('[data-brew-guide]').forEach(function (root) {
      root.querySelector('[data-guide-kicker]').textContent = method.kicker;
      root.querySelector('[data-guide-title]').textContent = method.title;
      root.querySelector('[data-guide-intro]').textContent = method.intro;
      root.querySelector('[data-spec-leaf]').textContent = method.leaf;
      root.querySelector('[data-spec-water]').textContent = method.water;
      root.querySelector('[data-spec-temp]').textContent = method.temp;
      root.querySelector('[data-spec-time]').textContent = method.time;
      root.querySelector('[data-sommelier-note]').textContent = method.note;
      root.querySelector('[data-good-for]').textContent = method.good;
      root.querySelectorAll('[data-brew-method]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.brewMethod === key);
      });
      const steps = root.querySelector('[data-guide-steps]');
      steps.innerHTML = '';
      method.steps.forEach(function (step, index) {
        const article = document.createElement('article');
        article.className = 'db-step';
        article.innerHTML = '<div class="db-step-num">' + String(index + 1).padStart(2, '0') + '</div><strong>' + step[0] + '</strong><p>' + step[1] + '</p>';
        steps.appendChild(article);
      });
    });
  }

  function openMethod(key) {
    renderGuide(key);
    const guide = document.querySelector('[data-brew-guide]');
    if (guide) guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initFinder(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('[data-brew-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        const group = button.closest('[data-question]');
        group.querySelectorAll('[data-brew-choice]').forEach(function (choice) { choice.classList.remove('is-active'); });
        button.classList.add('is-active');
        state[group.dataset.question] = button.dataset.value;
        renderFinder(root);
      });
    });
    renderFinder(root);
  }

  function initMethodButtons(scope) {
    scope.querySelectorAll('[data-brew-method]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () { openMethod(button.dataset.brewMethod); });
    });
  }

  function initVariables(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const labels = { leaf: ['Lighter', 'Balanced', 'More leaf'], temp: ['Cooler', 'Medium', 'Hotter'], time: ['Shorter', 'Balanced', 'Longer'] };
    function update() {
      const leaf = Number(root.querySelector('[data-variable="leaf"]').value);
      const temp = Number(root.querySelector('[data-variable="temp"]').value);
      const time = Number(root.querySelector('[data-variable="time"]').value);
      root.querySelector('[data-value="leaf"]').textContent = labels.leaf[leaf];
      root.querySelector('[data-value="temp"]').textContent = labels.temp[temp];
      root.querySelector('[data-value="time"]').textContent = labels.time[time];
      const intensity = leaf + temp + time;
      let title = 'A clear, balanced cup';
      let copy = 'A middle starting point: enough aroma and body to understand the tea, with room to adjust the second cup in either direction.';
      let rule = 'Taste first. Change only one variable for the next brew.';
      if (intensity <= 1) {
        title = 'A softer, quieter cup';
        copy = 'Expect less body and less bitterness. Delicate sweetness may become clearer, though aroma can feel restrained.';
        rule = 'When the cup feels empty rather than delicate, add leaf before adding much more time.';
      } else if (intensity >= 5) {
        title = 'A fuller, more forceful cup';
        copy = 'Expect more body, darker aroma and a longer finish, with a greater chance of dryness or bitterness.';
        rule = 'When the cup becomes rough, reduce temperature or time before removing too much leaf.';
      } else if (temp === 0 && time === 2) {
        title = 'Slow extraction, softer edges';
        copy = 'Longer time with cooler water can increase sweetness and texture while keeping sharp bitterness lower.';
        rule = 'This combination is especially useful for shaded and delicate green teas.';
      } else if (temp === 2 && time === 2) {
        title = 'High extraction';
        copy = 'Hotter water and longer time release aroma quickly, but can also pull dryness and woody bitterness.';
        rule = 'Use this only when the tea is very robust or the cup still tastes thin.';
      }
      root.querySelector('[data-variable-title]').textContent = title;
      root.querySelector('[data-variable-copy]').textContent = copy;
      root.querySelector('[data-variable-rule]').textContent = rule;
    }
    root.querySelectorAll('[data-variable]').forEach(function (input) { input.addEventListener('input', update); });
    update();
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-brew-finder]').forEach(initFinder);
    root.querySelectorAll('[data-brew-variables]').forEach(initVariables);
    initMethodButtons(root);
    if (document.querySelector('[data-brew-guide]') && !document.documentElement.dataset.brewGuideSeeded) {
      document.documentElement.dataset.brewGuideSeeded = 'true';
      renderGuide('gongfu');
    }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
